import { useEffect, useState } from "react";
import { registerSW } from "virtual:pwa-register";

export function useUpdatePWA({ autoUpdate = false }) {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [updateSW, setUpdateSW] = useState<any>(null);

  useEffect(() => {
    const intervalMS = 60 * 60 * 1000;
    const { updateServiceWorker }: any = registerSW({
      onNeedRefresh() {
        setUpdateAvailable(true);
        if (autoUpdate) {
          (updateServiceWorker as any)();
        }
      },
      onOfflineReady() {
        console.log("App is ready for offline use");
      },
      immediate: true,
    });

    setUpdateSW(() => updateServiceWorker);

    const interval = setInterval(() => {
      (updateServiceWorker as any)();
    }, intervalMS);

    return () => clearInterval(interval);
  }, [autoUpdate]);

  const installUpdate = () => {
    if (updateAvailable && updateSW) {
      (updateSW as any)();
    }
  };

  const dismissUpdate = () => {
    setUpdateAvailable(false);
  };

  return { updateAvailable, installUpdate, dismissUpdate };
}
